export default {
  currentRequestLock: null,
  editorFilesApiCalls: 0,
  editorFilesApiCallLabel: null,
};
